export function ucFirst(string: string) {
	return string[0].toUpperCase() + string.slice(1);
}

/**
 * Converts a string into a URL-friendly "slug".
 *
 * This function will:
 * 1. Normalize accented characters to their base letter and remove the accent marks.
 * 2. Convert the string to lowercase.
 * 3. Replace spaces and other whitespace with a single hyphen.
 * 4. Remove any characters that are not alphanumeric or a hyphen.
 * 5. Collapse multiple consecutive hyphens into a single one.
 * @param text The string to convert.
 * @returns A URL-friendly slug.
 */
export function slugify(text: string): string {
	return text
		.normalize('NFD') // Decompose accented characters into base characters and diacritics
		.replace(/[\u0300-\u036f]/g, '') // Remove the diacritics
		.toLowerCase()
		.trim()
		.replace(/\s+/g, '-') // Replace spaces with -
		.replace(/[^\w-]+/g, '') // Remove all non-word chars except hyphens
		.replace(/--+/g, '-'); // Replace multiple - with single -
}
